import { render, staticRenderFns } from "./VisitChain.vue?vue&type=template&id=32bef01c&scoped=true&"
import script from "./VisitChain.vue?vue&type=script&lang=js&"
export * from "./VisitChain.vue?vue&type=script&lang=js&"
import style0 from "./VisitChain.vue?vue&type=style&index=0&id=32bef01c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bef01c",
  null
  
)

export default component.exports